/* src/app/dashboard/standards-reference/standards-reference.component.scss */
/*# sourceMappingURL=standards-reference.component-UE2FT5CT.css.map */
